import { hideAllModals, showExitModal, showModal } from './modal';
export const initNavigation = () => {
    const pages = document.querySelectorAll('.page');
    const navigateToHash = (hash) => {
        hideAllModals();
        const targetModal = document.querySelector('.modal[data-identifier="' + hash + '"]');
        if (targetModal) {
            showModal(targetModal);
            return;
        }
        const targetComponent = document.querySelector('.component[data-identifier="' + hash + '"]');
        if (targetComponent) {
            scrollToComponent(targetComponent);
            return;
        }
        const targetPage = document.querySelector('#page-' + hash);
        if (targetPage) {
            activateTargetPage(targetPage);
        }
    };
    const activateTargetPage = (targetPage) => {
        const activePage = document.querySelector('.page.active') || pages[0];
        for (const page of pages) {
            page.classList.toggle('active', page === targetPage);
            page.classList.toggle('inactive', page !== targetPage);
        }
        if (activePage === targetPage && targetPage === pages[0] && window.scrollY < 50) {
            showExitModal();
            return;
        }
        if (typeof targetPage.dataset['product'] === 'string') {
            window.page.product = targetPage.dataset['product'];
        }
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        document.querySelectorAll('a').forEach((link) => {
            link.classList.toggle('active', typeof link.href === 'string' &&
                link.getAttribute('href')?.startsWith('#') &&
                'page-' + link.getAttribute('href').substring(1) === targetPage.id);
        });
        window.dispatchEvent(new Event('pageChange'));
    };
    const scrollToComponent = (targetComponent) => {
        const containingPage = targetComponent.closest('.page');
        if (containingPage && !containingPage.classList.contains('active')) {
            activateTargetPage(containingPage);
            targetComponent.scrollIntoView({
                behavior: 'instant',
            });
            return;
        }
        targetComponent.scrollIntoView({
            behavior: 'smooth',
        });
    };
    window.addEventListener('hashchange', (event) => {
        const newUrl = new URL(event.newURL);
        newUrl.hash ? navigateToHash(newUrl.hash.substring(1)) : navigateToHash(window.firstPageIdentifier);
    });
    document.querySelectorAll('a[href^="#"]').forEach((link) => link.addEventListener('click', (event) => {
        const targetUrl = new URL(link.href);
        if (window.location.hash === targetUrl.hash) {
            navigateToHash(targetUrl.hash.substring(1));
        }
    }));
    if (window.location.hash && window.location.hash !== '#' + window.firstPageIdentifier) {
        return navigateToHash(window.location.hash.substring(1));
    }
};
